<template>
  <div v-if="isLoadingPage">
    <BaseSpinner
      height="100px"
      width="100px"
      v-if="isSpinning"
    />
  </div>
  <div
    class="base-table"
    v-else
  >
    <PageTitle>Brugeradministration</PageTitle>
    <p v-if="collection.length === 0">
      Der er ingen oprettede brugere.
    </p>

    <div class="row">
      <div
        class="col-xs-12"
        v-if="collection.length"
      >
        <div class="row bottom-xs base-table__header">
          <p class="col-xs-3 col-md-2">
            Rolle
          </p>
          <p class="col-xs-5 col-md-8">
            Brugernavn
          </p>
        </div>
        <Box
          v-for="(user, userIndex) in collection"
          :key="userIndex"
          :open="user.editMode"
        >
          <div class="row">
            <div class="col-xs-3 col-md-2">
              {{ user.isAdministrator | IsAdmin }}
            </div>
            <div class="col-xs-5 col-md-8">
              <p>{{ user.email }}</p>
            </div>
            <div class="col-xs-2 end-xs">
              <font-awesome-icon
                class="base-table__icon-edit"
                icon="pencil-alt"
                @click="toggleEditMode(user, false)"
              />
              <font-awesome-icon
                class="base-table__icon-edit users-password-space"
                icon="key"
                @click="toggleUpdatePasswordMode(user, true)"
              />
              <font-awesome-icon
                class="base-table__icon-delete"
                icon="trash-alt"
                @click="deletePrompt(user)"
              />
            </div>
          </div>
          <div
            class="row"
            v-if="user.editMode"
          >
            <div class="col-xs-12">
              <UpdateUser
                :form="user"
                :update-password="updatePassword"
              />
            </div>
          </div>
        </Box>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <CreateUser @created="created" />
      </div>
    </div>
  </div>
</template>

<script>
import UpdateUser from '../components/Forms/Users/UpdateUser.vue';
import CreateUser from '../components/Forms/Users/CreateUser.vue';
import BaseSpinner from '../components/BaseSpinner.vue';
import Box from '../components/Box.vue';
import UserService from '../services/UserService';
import Pageload from '../mixins/Pageload';
import Request from '../mixins/Request';
import IsAdmin from '../filters/IsAdmin';

export default {
    name: 'Users',
    mixins: [Pageload, Request],
    components: {
        Box, BaseSpinner, CreateUser, UpdateUser,
    },
    filters: { IsAdmin },
    data() {
        return {
            collection: [],
            updatePassword: false,
        };
    },
    methods: {
        toggleEditMode(user) {
            if (!this.updatePassword && user.editMode) {
                this.$set(user, 'editMode', false);
                return;
            }
            this.updatePassword = false;

            this.$set(user, 'editMode', true);
        },
        toggleUpdatePasswordMode(user) {
            if (this.updatePassword && user.editMode) {
                this.$set(user, 'editMode', false);
                this.updatePassword = false;
                return;
            }

            this.updatePassword = true;
            this.$set(user, 'editMode', true);
        },
        created(user) {
            this.collection.push(user);
        },
        async deleteAction(api) {
            try {
                const apiIndex = this.collection.findIndex(a => a === api);
                if (apiIndex === -1) {
                    return;
                }

                await UserService.delete(api);
                this.$delete(this.collection, apiIndex);
                this.$snotify.success('Slettet.');
            } catch (error) {
                //
            }
        },
        deletePrompt(user) {
            this.$snotify.confirm(`Vil du slette ${user.email}?`, {
                timeout: 5000,
                buttons: [
                    {
                        text: 'Ja',
                        action: (toast) => {
                            this.deleteAction(user);
                            this.$snotify.remove(toast.id);
                        },
                        bold: false,
                    },
                    {
                        text: 'Fortryd',
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        },
                        bold: true,
                    },
                ],
            });
        },
    },
    async created() {
        try {
            await this.requestData({ service: UserService.getAll, storage: 'collection' });
        } catch (error) {
            //
        }
    },
};
</script>

<style lang="scss" scoped>
.users-password-space {
    margin-left: 20px;
    fill: $green;
}

.wada-link {
    margin-top: 10px;
    display: inline-block;
}
</style>
